<template>
    <b-overlay :show="loading" rounded="sm">
        <b-card title="Dados de Endereço">
            <b-form @submit.stop.prevent="submit" class="row g-1">
                <div class="col-md-4">

                    <b-form-group label="CEP">
                        <input
                            type="tel"
                            v-mask="'#####-###'"
                            placeholder="00000-000"
                            :value="form.zip_code"
                            @input="changeZipCodeInput"
                            class="form-control"
                        />
                        <has-errors :errors="errors" name="zip_code" />
                    </b-form-group>

                </div>
                <!-- Estado -->
                <div class="col-md-4">
                    <b-form-group label="Estado">
                        <b-form-select
                            v-model="form.state"
                            :options="statesOfBrazil"
                        />
                        <has-errors :errors="errors" name="state" />
                    </b-form-group>
                </div>

                <!-- Cidade -->
                <div class="col-md-4">
                    <b-form-group label="Cidade">
                        <b-form-input
                            v-model="form.city"
                            placeholder="ex: São Paulo"
                        />
                        <has-errors :errors="errors" name="city" />
                    </b-form-group>
                </div>



                <!-- Endereço -->
                <div class="col-md-7">
                    <b-form-group label="Endereço">
                        <b-form-input
                            v-model="form.street"
                            placeholder="ex: Av. Paulista"
                        />
                        <has-errors :errors="errors" name="street" />
                    </b-form-group>
                </div>

                <div class="col-md-5">
                    <b-form-group label="Número">
                        <b-form-input
                            v-model="form.number"
                            placeholder="ex: 123"
                        />
                        <has-errors :errors="errors" name="number" />
                    </b-form-group>
                </div>

                <!-- Submit -->
                <div class="col-12">
                    <b-button type="submit" variant="primary" :disable="loading">
                        Atualizar
                    </b-button>
                </div>
            </b-form>
        </b-card>
    </b-overlay>
</template>

<script>
import cep from '../pagarme/customer/mixins/cep'
import hasErrors from '../../../components/HasError.vue'

export default {
    mixins: [cep],
    components: {
        hasErrors
    }, 
    props: ['endpointShow', 'endpointUpdate'],
    data() {
        return {
            loading: false,
            errors: {},
            form: {
                zip_code: null,
                street: null,
                state: null,
                city: null,
                id: null,
                number: null

            },
            hasAddress: true,
        }
    },
    created() {
        this.load();
    },
    methods: {

        load() {
            this.loading = true;
            axios.get(this.endpointShow)
                .then((result) => {
                    const response = result.data.data
                    this.form.zip_code = response.address.zip_code
                    this.form.street = response.address.address
                    this.form.city = response.address.city
                    this.form.state = response.address.state
                    this.form.id = response.address.id
                    this.form.number = response.address.number

                    this.hasAddress = true;

                })
                .catch((result)=> {
                    this.hasAddress = false;
                })
                .finally(() => this.loading = false)
        },

        store(){

            axios.post(`${this.endpointUpdate}`, {
                address: this.form.street,
                zip_code: this.form.zip_code,
                city: this.form.city,
                state: this.form.state,
                number: this.form.number,
                country: 'BR',


            })
            .then((result) => {
                this.$toast.success('Salvo com sucesso')
            }).catch((err) => {
                this.errors = this.setErrors(err)
            })
            .finally(()=> this.loading = false);
        },

        submit(){
            this.loading = true

            if(this.hasAddress){

                axios.put(`${this.endpointUpdate}/${this.form.id}`, {
                    address: this.form.street,
                    zip_code: this.form.zip_code,
                    city: this.form.city,
                    state: this.form.state,
                    number: this.form.number,   
                    country: 'BR',
    
    
                })
                .then((result) => {
                    this.$toast.success('Atualizado com sucesso')
                }).catch((err) => {
                    this.errors = this.setErrors(err)
                })
                .finally(()=> this.loading = false);
            }

            else{
                
                this.store()
            }
        }

    }
}
</script>

<style scoped>

</style>
